import React from 'react';
import { Image, Text, View } from 'react-native';
import { getDefaultGlobJSON } from '../defaultConfigurations/MainConfigurations';
import { textPrimary_10_4, textPrimary_8_1, textPrimary_9_3 } from './SimulatorsComponents/AuxiliaryComponent/TextComponent/TextStyle';
import { img_expand } from '../utils/ImagesManagementUtils';
import { Exclamation_mark } from '../utils/DictionaryManagementUtils';

//= ========================================================================
const MyAccountLine = ({
  globJSON,
  txtAmount,
  txtPrimary,
  txtSecondary,
  isPositive,
  showTheme = true,
  simPlatform,
  isPending,
  isDate,
}) => {
  //----------------------------------------------------------
  const { colors } = showTheme ? globJSON.configurations.theme : getDefaultGlobJSON().configurations.theme;
  const { app_background_color } = colors;
  const { secondary_font_color } = colors;
  const { primary_font_color } = colors;
  const { positive_color } = colors;
  const { negative_color } = colors;
  const myStyles = {
    container: {
      width: 240,
      height: isDate ? 28 : 38,
      paddingTop: 17,
      paddingRight: 6,
      backgroundColor: app_background_color,
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    flexColumn: {
      flexDirection: 'column',
    },
    flexRow: {
      flexDirection: 'row',
    },
    price: {
      backgroundColor: isPending && '#f7fafc',
      borderRadius: 5,
      padding: 4,
      alignItems: 'center',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    imgExpand: {
      width: 3,
      height: 5,
      marginLeft: 2,
      tintColor: primary_font_color,
    },
    exclamationMark: {
      width: 9,
      height: 9,
      borderRadius: 4.5,
      marginHorizontal: 4,
      marginTop: 1,
      paddingHorizontal: 3.4,
      backgroundColor: isPending && negative_color,
      color: '#ffffff',
      fontSize: 7,
      fontWeight: 'bold',
      top: 0,
    },
  };

  return (

    <View style={myStyles.container}>
      <View style={myStyles.flexColumn}>
        <View style={myStyles.flexRow}>
          <Text style={myStyles.exclamationMark}>{Exclamation_mark}</Text>
          <Text style={[textPrimary_9_3(globJSON, simPlatform), { fontWeight: !isDate && 600 }]}>{txtPrimary}</Text>
        </View>
        <Text style={[textPrimary_8_1(globJSON, simPlatform), { color: secondary_font_color, marginLeft: 18 }]}>{txtSecondary}</Text>
      </View>
      <View style={myStyles.price}>
        <Text style={[textPrimary_10_4(globJSON, simPlatform), { color: isPositive && positive_color }]}>
          {txtAmount}
        </Text>
        {isPending && (
        <Image
          fadeDuration={0}
          style={myStyles.imgExpand}
          source={img_expand}
        />
        )}
      </View>
    </View>
  );
};

export default MyAccountLine;
